// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","869":"styles"}[chunkId] + "-" + {"245":"0d4fe3599f84db85a290","453":"936ec7def098c04a4a51","869":"be45575bc48f81291b36"}[chunkId] + ".js";
};